export default function flatten(obj: object, prefix?: string): object {
    if (typeof(obj) !== "object") {
        if (!prefix)
            return obj;

        return {
            [prefix]: obj
        };
    }

    return Object.entries(obj).reduce((result, [key, value]) => ({
        ...result,
        ...(flatten(value, [prefix, key].filter(Boolean).join(".")))
    }), {});
}